import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import authService from './services/authService';

// Pages (to be created)
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import StudentsPage from './pages/StudentsPage';
import MessPage from './pages/MessPage';
import HostelPage from './pages/HostelPage';
import PaymentsPage from './pages/PaymentsPage';
import EmployeesPage from './pages/EmployeesPage';
import EmployeeManagementPage from './pages/EmployeeManagementPage';
import AgreementsPage from './pages/AgreementsPage';
import RegistrationApprovalsPage from './pages/RegistrationApprovalsPage';
import SettingsPage from './pages/SettingsPage';
import LateMarkReportingPage from './pages/LateMarkReportingPage';
import LeaveApprovalPage from './pages/LeaveApprovalPage';
import ShiftManagementPage from './pages/ShiftManagementPage';
import NotificationsPage from './pages/NotificationsPage';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  return authService.isAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/students"
          element={
            <ProtectedRoute>
              <StudentsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/registration-approvals"
          element={
            <ProtectedRoute>
              <RegistrationApprovalsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/mess"
          element={
            <ProtectedRoute>
              <MessPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/hostel"
          element={
            <ProtectedRoute>
              <HostelPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/payments"
          element={
            <ProtectedRoute>
              <PaymentsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/employees"
          element={
            <ProtectedRoute>
              <EmployeesPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/employee-management"
          element={
            <ProtectedRoute>
              <EmployeeManagementPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/agreements"
          element={
            <ProtectedRoute>
              <AgreementsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/late-mark-reporting"
          element={
            <ProtectedRoute>
              <LateMarkReportingPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/leave-approval"
          element={
            <ProtectedRoute>
              <LeaveApprovalPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/shift-management"
          element={
            <ProtectedRoute>
              <ShiftManagementPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          }
        />
        
        <Route
          path="/notifications"
          element={
            <ProtectedRoute>
              <NotificationsPage />
            </ProtectedRoute>
          }
        />
        
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
